import { useRouteError, isRouteErrorResponse, Link } from "react-router";

export function ErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center px-6">
        <div className="max-w-2xl text-center">
          <div className="mb-8">
            <h1 className="text-8xl md:text-9xl font-black bg-gradient-to-r from-violet-400 via-fuchsia-400 to-cyan-400 bg-clip-text text-transparent mb-4">
              {error.status}
            </h1>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              {error.status === 404 ? "Page Not Found" : "Oops! Something went wrong"}
            </h2>
            <p className="text-gray-400 text-lg mb-8">
              {error.statusText || error.data?.message || "The page you're looking for doesn't exist."}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="px-8 py-4 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white rounded-xl font-semibold hover:from-violet-500 hover:to-fuchsia-500 transition-all duration-300 shadow-lg shadow-violet-500/50"
            >
              Go Home
            </Link>
            <button
              onClick={() => window.history.back()}
              className="px-8 py-4 bg-gradient-to-r from-gray-700 to-gray-800 text-white rounded-xl font-semibold hover:from-gray-600 hover:to-gray-700 transition-all duration-300"
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    );
  }

  // For non-route errors
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-6">
      <div className="max-w-2xl text-center">
        <div className="mb-8">
          <h1 className="text-5xl md:text-6xl font-black bg-gradient-to-r from-red-400 via-orange-400 to-yellow-400 bg-clip-text text-transparent mb-4">
            Unexpected Error
          </h1>
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Something went wrong
          </h2>
          <p className="text-gray-400 text-lg mb-4">
            We apologize for the inconvenience. Please try refreshing the page.
          </p>
          {error instanceof Error && (
            <details className="mt-4 text-left">
              <summary className="cursor-pointer text-violet-400 hover:text-violet-300 mb-2">
                Technical Details
              </summary>
              <div className="bg-gray-900 rounded-lg p-4 text-sm font-mono text-red-400 overflow-auto">
                <p className="mb-2 font-bold">{error.message}</p>
                {error.stack && (
                  <pre className="text-gray-500 text-xs overflow-x-auto">{error.stack}</pre>
                )}
              </div>
            </details>
          )}
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="px-8 py-4 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white rounded-xl font-semibold hover:from-violet-500 hover:to-fuchsia-500 transition-all duration-300 shadow-lg shadow-violet-500/50"
          >
            Go Home
          </Link>
          <button
            onClick={() => window.location.reload()}
            className="px-8 py-4 bg-gradient-to-r from-gray-700 to-gray-800 text-white rounded-xl font-semibold hover:from-gray-600 hover:to-gray-700 transition-all duration-300"
          >
            Refresh Page
          </button>
        </div>
      </div>
    </div>
  );
}